import AlphaDonorInfo from './alpha'
import BetaDonorInfo from './beta'

export const Alpha = AlphaDonorInfo
export const Beta = BetaDonorInfo
